import { axiosPost } from "@/services/axiosService";

export type FrontendTrackErrorPayload = {
  source?: string;
  surface?: string;
  category?: string;
  query?: string;
  errorType?: string;
  tags?: string[];
  request?: {
    method?: string;
    url?: string;
    statusCode?: number;
    queryRequestId?: string;
    hostname?: string;
    pathname?: string;
  };
  context?: {
    botId?: string;
    botCustomId?: string;
    namespace?: string;
    companyId?: string;
    contactId?: string;
    userResponseId?: string;
    queryRequestId?: string;
    socketRoomId?: string;
    modelName?: string;
    apiKeyStatus?: string;
    streaming?: boolean;
    includeSource?: boolean;
    isPreview?: boolean;
    socialType?: string;
    userId?: string;
    hostname?: string;
    pathname?: string;
    fromOutgrow?: boolean;
    location?: string;
    aiIntegration?: {
      provider?: string;
    };
    aiConfig?: {
      userId?: string;
    };
  };
  error?: {
    name?: string;
    message?: string;
    stack?: string;
    code?: string;
    cause?: string | null;
    raw?: unknown;
  };
};

type LegacyTrackErrorPayload = ReturnType<typeof normalizeLegacyError>;

function normalizeLegacyError(err: Error) {
  let wholeErr = "";

  try {
    wholeErr = JSON.stringify(err);
  } catch (stringifyError) {
    console.log(stringifyError);
  }

  return {
    name: err.name ?? "",
    message: err.message ?? "",
    stack: err.stack ?? "",
    cause: typeof err.cause === "string" ? err.cause : "",
    ...(wholeErr ? { wholeErr } : {}),
  };
}

function postTrackError(
  payload: FrontendTrackErrorPayload | LegacyTrackErrorPayload,
) {
  console.error(payload);

  axiosPost("/liveBot/track-error", payload).catch((err) => {
    console.log(err);
  });
}

function isFrontendTrackErrorPayload(
  value: Error | FrontendTrackErrorPayload,
): value is FrontendTrackErrorPayload {
  return (
    "error" in value ||
    "query" in value ||
    "request" in value ||
    "context" in value ||
    "source" in value
  );
}

export function trackFrontendError(payload: FrontendTrackErrorPayload) {
  postTrackError({
    source: "frontend",
    surface: "livebot",
    category: "query",
    ...payload,
  });
}

export default function trackError(err: Error | FrontendTrackErrorPayload) {
  if (isFrontendTrackErrorPayload(err)) {
    trackFrontendError(err);
    return;
  }

  postTrackError(normalizeLegacyError(err));
}
